import { mapsEmbedSrc } from '@/lib/format'

interface MapEmbedProps {
  lat: number | null
  lng: number | null
  address: string
  title: string
}

/** Mapa de contexto; la navegación completa permanece en el enlace “Abrir en Google Maps”. */
export function MapEmbed({ lat, lng, address, title }: MapEmbedProps) {
  return (
    <iframe
      className="accesos__map"
      src={mapsEmbedSrc(lat, lng, address)}
      title={title}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  )
}
